export default "__VITE_ASSET__tVD9Z22a__$_?url__"